import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Icon } from 'audamatic-ui';
import { t } from '@utils/i18n';
import Text from '@text';
import { IS_B2B } from '@config';
import './styles.scss';

const OrderlineReference = (props) => {
  const { value = '', stacked, wide, showConfirmationButtonOrderline, changeReference, showErrorMessage } = props;
  const [reference, setReference] = useState(value);


  const updateText = (e) => {
    const maxCharacters = 35;
    const newValue = e.target.value;
    const specialChars = /[`@#$%^&*_+\=\[\]{};'"\\|<>\/~\n(.,:)!?àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]/;
    let validValue = '';

    if ((newValue.length > maxCharacters) || (specialChars.test(newValue))) {
      validValue = newValue.substring(0, maxCharacters).replace(specialChars, '');
      showErrorMessage?.(true);
    } else {
      validValue = newValue;
      showErrorMessage?.(false);
    }
    showConfirmationButtonOrderline?.();
    setReference(validValue);
    changeReference(validValue);
  };

  if (!IS_B2B) {
    return null;
  }
  return (
    <div className={`orderline-reference ${stacked ? 'stacked' : ''}`} data-test-id="ordellineReference">
      <textarea
        placeholder={t('orderline-reference.placeholder')}
        rows={wide ? 1 : 2}
        onChange={updateText}
        value={reference}
      />
      <div className="info">
        <Tooltip position="top" content={<Text>orderline-reference.tooltip</Text>}>
          <Icon name="InfoCircleSolid" size="xs"/>
        </Tooltip>
      </div>
    </div>
  );
};

OrderlineReference.propTypes = {
  stacked: PropTypes.bool,
  wide: PropTypes.bool,
  showConfirmationButtonOrderline: PropTypes.func,
  value: PropTypes.string,
  changeReference: PropTypes.func,
  showErrorMessage: PropTypes.func,
};
export default OrderlineReference;
